import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const csTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Jméno (malá písmena, žádné speciální znaky)',
    add: 'Přidat',
    allowedFileTypes: 'Povolené typy souborů',
    allowedFileTypesDescription:
      'Omezte povolené typy souborů (např. obrázek/*, aplikace/pdf). Chcete-li povolit všechny typy, ponechte prázdné.',
    allowMultipleFiles: 'Povolit více souborů',
    amountInCents: 'Částka v centech',
    basePrice: 'Základní cena',
    bcc: 'BCC',
    brand: 'Značka',
    cc: 'CC',
    checkboxPlural: 'Zaškrtávací políčko Pole',
    checkboxSingular: 'Zaškrtávací políčko',
    checkedByDefault: 'Ve výchozím nastavení zaškrtnuto',
    chooseConfirmationType:
      'Vyberte, zda chcete po odeslání formuláře zobrazit zprávu na stránce nebo přesměrovat na jinou stránku.',
    condition: 'Podmínka',
    confirmationMessage: 'Potvrzující zpráva',
    confirmationType: 'Typ potvrzení',
    countryPlural: 'Země Pole',
    countrySingular: 'země',
    creditCard: 'Kreditní karta',
    customURL: 'Vlastní adresa URL',
    datePlural: 'Datumová pole',
    dateSingular: 'Datum',
    defaultValue: 'Výchozí hodnota',
    divide: 'Rozdělit',
    documentToLinkTo: 'Dokument, na který se má odkazovat',
    doesNotEqual: 'Nerovná se',
    emailFrom: 'Email od',
    emailPlural: 'Pole e-mailu',
    emailsDescription:
      'Odešlete vlastní e-maily při odeslání formuláře. Chcete-li odeslat stejný e-mail více příjemcům, použijte seznamy oddělené čárkami. Chcete-li odkazovat na hodnotu z tohoto formuláře, zabalte název pole do dvojitých složených závorek, tj. {{firstName}}. Pro výstup všech dat můžete použít zástupný znak {{*}} a {{*:table}} je naformátovat jako HTML tabulku v e-mailu.',
    emailSingular: 'Email',
    emailTo: 'Email Komu',
    equals: 'rovná se',
    field: 'pole',
    fields: 'Pole',
    fieldWidth: 'Šířka pole (v procentech)',
    hasAnyValue: 'Má jakoukoli hodnotu',
    internalLink: 'Interní odkaz',
    label: 'Štítek',
    maxFileSize: 'Maximální velikost souboru (bajty)',
    maxFileSizeDescription: 'Maximální velikost souboru v bajtech. Nechte prázdné bez omezení.',
    message: 'Zpráva',
    messageDescription: 'Zadejte zprávu, která má být odeslána v tomto e-mailu.',
    messagePlural: 'Bloky zpráv',
    messageSingular: 'Zpráva',
    mimeType: 'Typ MIME',
    mimeTypePlural: 'Typy MIME',
    mimeTypeSingular: 'Typ MIME',
    multiply: 'Vynásobte',
    numberPlural: 'Pole čísel',
    numberSingular: 'Číslo',
    optionPlural: 'Možnosti',
    optionSingular: 'Možnost',
    paymentFieldPlural: 'Platební pole',
    paymentFieldSingular: 'Platba',
    paymentProcessor: 'Zpracovatel plateb',
    paymentStatus: 'Stav',
    placeholder: 'Zástupný symbol',
    priceConditions: 'Cenové podmínky',
    priceConditionsPlural: 'Cenové podmínky',
    priceConditionsSingular: 'Cenová podmínka',
    radioOptions: 'Možnosti rádiových atributů',
    radioPlural: 'Rádiová pole',
    radioSingular: 'Rádio',
    redirect: 'Přesměrování',
    replyTo: 'Odpovědět',
    required: 'Povinné',
    selectOptions: 'Vyberte Možnosti',
    selectPlural: 'Vyberte Pole',
    selectSingular: 'Vyberte',
    statePlural: 'Státní pole',
    stateSingular: 'stát',
    staticValue: 'Statická hodnota',
    subject: 'Předmět',
    submitButton: 'Odeslat štítek tlačítka',
    subtract: 'Odečíst',
    textareaPlural: 'Pole textové oblasti',
    textareaSingular: 'Textarea',
    textPlural: 'Textová pole',
    textSingular: 'Text',
    title: 'Název',
    token: 'žeton',
    uploadCollection: 'Nahrát sbírku',
    uploadCollectionDescription: 'Vyberte, do které kolekce pro nahrání se mají ukládat soubory',
    uploadFieldPlural: 'Nahrát pole',
    uploadFieldSingular: 'Nahrát',
    urlToRedirectTo: 'URL pro přesměrování',
    value: 'Hodnota',
    valueOfField: 'Hodnota pole',
    valueType: 'Typ hodnoty',
  },
}

export const cs: PluginLanguage = {
  dateFNSKey: 'cs',
  translations: csTranslations,
}
